export const RELATED_POSTS_WIDGET_BUNDLE_NAME = 'related-posts-widget';
